import { Routes, Route, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import FirstBloodOverlay from "./components/FirstBloodOverlay";
import LandingPage from "./pages/Landing";
import LoginPage from "./pages/Login";
import RegisterPage from "./pages/Register";
import ChallengesPage from "./pages/Challenges";
import ScoreboardPage from "./pages/Scoreboard";
import TeamPage from "./pages/Team";
import AdminPage from "./pages/Admin";
import EffectsPage from "./pages/Effects";
import ProfilePage from "./pages/Profile";
import TerminalChatPage from "./pages/TerminalChat";
import WatchPage from "./pages/Watch";

export default function App() {
  return (
    <ErrorBoundary>
      <FirstBloodOverlay />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<LandingPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route
            path="challenges"
            element={
              <ProtectedRoute>
                <ChallengesPage />
              </ProtectedRoute>
            }
          />
          <Route path="scoreboard" element={<ScoreboardPage />} />
          <Route
            path="team"
            element={
              <ProtectedRoute>
                <TeamPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="terminal"
            element={
              <ProtectedRoute>
                <TerminalChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="watch"
            element={
              <ProtectedRoute>
                <WatchPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin"
            element={
              <ProtectedRoute roles={["SUPER_ADMIN", "ORGANIZER"]}>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/effects"
            element={
              <ProtectedRoute roles={["SUPER_ADMIN", "ORGANIZER"]}>
                <EffectsPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
